import { Grid, Paper } from '@material-ui/core'
import styled from 'styled-components'

export const Container = styled(Grid)``

export const PaperStyled = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2)}px;
`
